import { useAtomValue } from "jotai";

import { $isCloning } from "../../internal/clone-document/clone-state.atom";

export const useIsCloning = (documentId: string) => {
	return useAtomValue($isCloning(documentId));
};
